import { jwtDecode } from "jwt-decode";

const uri = `${import.meta.env.VITE_BASE_URL}/api`;

const SignIn = async (username, password) => {
  try {
    const response = await fetch(`${uri}/login_check`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
        password,
      }),
    });
    const data = await response.json();
    if (response.status === 200) {
      const decode = jwtDecode(data.token);
      const roles = decode.roles;
      if (roles.includes("ROLE_ADMIN")) {
        return {
          success: true,
          token: data.token,
        };
      } else {
        return {
          success: false,
          message: "Bạn phải đăng nhập với quyền admin.",
        };
      }
    } else {
      return { success: false, message: "Sai tài khoản hoặc mật khẩu." };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

export default SignIn;
